<template>
  <div id="signup">
    <div class="signup-form">
      <form @submit.prevent="onSubmit">
        <div class="input" :class="{invalid: $v.name.$error}">
          <label for="name">Nombre</label>
          <input
                  type="text"
                  id="name"
                  @blur="$v.name.$touch()"
                  v-model="name">
          <p v-if="$v.name.$error">Este campo no puede estas vacio.</p>
        </div>
        <div class="input" :class="{invalid: $v.lastName.$error}">
          <label for="lastName">Apellidos</label>
          <input
                  type="text"
                  id="lastName"
                  @blur="$v.lastName.$touch()"
                  v-model="lastName">
          <p v-if="$v.lastName.$error">Este campo no puede estas vacio.</p>
        </div>
        <div class="input" :class="{invalid: $v.email.$error}">
          <label for="email">Email</label>
          <input
                  type="email"
                  id="email"
                  @blur="$v.email.$touch()"
                  v-model="email">
          <p v-if="!$v.email.email">El email no es valido.</p>
          <p v-if="!$v.email.required">Este campo no puede estas vacio.</p>
        </div>
        <div class="input" :class="{invalid: $v.age.$error}">
          <label for="age">Edad</label>
          <input
                  type="number"
                  id="age"
                  @blur="$v.age.$touch()"
                  v-model.number="age">
          <p v-if="!$v.age.minVal">Es necesario que sea mayor de {{ $v.age.$params.minVal.min }} años.</p>
        </div>
        <div class="input" :class="{invalid: $v.password.$error}">
          <label for="password">Contraseña</label>
          <input
                  type="password"
                  id="password"
                  @blur="$v.password.$touch()"
                  v-model="password">
        </div>
        <div class="input" :class="{invalid: $v.confirmPassword.$error}">
          <label for="confirm-password">Confirmar Contraseña</label>
          <input
                  type="password"
                  id="confirm-password"
                  @blur="$v.confirmPassword.$touch()"
                  v-model="confirmPassword">
        </div>
        <div class="input">
          <label for="country">Pais</label>
          <select id="country" v-model="country">
            <option value="colombia">Colombia</option>
            <option value="india">India</option>
            <option value="uk">UK</option>
            <option value="germany">Germany</option>
          </select>
        </div>
        <!-- <div class="hobbies">
          <h3>Add some Hobbies</h3>
          <button @click="onAddHobby" type="button">Add Hobby</button>
          <div class="hobby-list">
            <div
                    class="input"
                    v-for="(hobbyInput, index) in hobbyInputs"
                    :class="{invalid: $v.hobbyInputs.$each[index].$error}"
                    :key="hobbyInput.id">
              <label :for="hobbyInput.id">Hobby #{{ index }}</label>
              <input
                      type="text"
                      :id="hobbyInput.id"
                      @blur="$v.hobbyInputs.$each[index].value.$touch()"
                      v-model="hobbyInput.value">
              <button @click="onDeleteHobby(hobbyInput.id)" type="button">X</button>
            </div>
            <p v-if="!$v.hobbyInputs.minLen">You have to specify at least {{ $v.hobbyInputs.$params.minLen.min }} hobbies.</p>
            <p v-if="!$v.hobbyInputs.required">Please add hobbies.</p>
          </div>
        </div> -->
        <div class="input inline" :class="{invalid: $v.terms.$invalid}">
          <input
                  type="checkbox"
                  id="terms"
                  @change="$v.terms.$touch()"
                  v-model="terms">
          <label for="terms">Accepto los terminos de uso</label>
        </div>
        <div class="submit">
          <button type="submit" :disabled="$v.$invalid">Registrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'
  import axios from 'axios'

  export default {
    data () {
      return {
        name: '',
        lastName: '',
        email: '',
        age: null,
        password: '',
        confirmPassword: '',
        country: 'colombia',
        hobbyInputs: [],
        terms: false
      }
    },
    validations: {
      name: {
        required
      },
      lastName: {
        required
      },
      email: {
        required,
        email,
        unique: true
        // val => {
        //   if (val === '') return true
        //   return axios.get('/users.json?orderBy="email"&equalTo="' + val + '"')
        //     .then(res => {
        //       return Object.keys(res.data).length === 0
        //     })
        // }
      },
      age: {
        required,
        numeric,
        minVal: minValue(18)
      },
      password: {
        required,
        minLen: minLength(6)
      },
      confirmPassword: {
//        sameAs: sameAs('password')
        sameAs: sameAs(vm => {
          return vm.password
        })
      },
      terms: {
        required: requiredUnless(vm => {
          return vm.country === 'germany'
        })
      },
      // hobbyInputs: {
      //   required,
      //   minLen: minLength(2),
      //   $each: {
      //     value: {
      //       required,
      //       minLen: minLength(5)
      //     }
      //   }
      // }
    },
    methods: {
      onAddHobby () {
        const newHobby = {
          id: Math.random() * Math.random() * 1000,
          value: ''
        }
        this.hobbyInputs.push(newHobby)
      },
      onDeleteHobby (id) {
        this.hobbyInputs = this.hobbyInputs.filter(hobby => hobby.id !== id)
      },
      onSubmit () {
        const formData = {
          name: this.name,
          lastName: this.lastName,
          email: this.email,
          age: this.age,
          password: this.password,
          confirmPassword: this.confirmPassword,
          country: this.country,
          hobbies: this.hobbyInputs.map(hobby => hobby.value),
          terms: this.terms
        }
        console.log(formData)
        this.$store.dispatch('signup2', formData)
      }
    }
  }
</script>

<style scoped>
  .signup-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .hobbies button {
    border: 1px solid #521751;
    background: #521751;
    color: white;
    padding: 6px;
    font: inherit;
    cursor: pointer;
  }

  .hobbies button:hover,
  .hobbies button:active {
    background-color: #8d4288;
  }

  .hobbies input {
    width: 90%;
  }

  .submit button {
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
  }

  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
</style>


// WEBPACK FOOTER //
// src/components/auth/signup.vue